import React from "react"
import * as Icon from "react-feather"
const navigationConfig = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={30} />,
    permissions: ["admin", "editor"],
    navLink: "/"
  }, {
    id: "view",
    title: "Organization Data",
    type: "collapse",
    icon: <Icon.Globe size={30} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "information",
        title: "Information",
        type: "item",
        icon: <Icon.Info size={10} />,
        navLink: "/view/information",
        permissions: ["admin", "editor"],
      }, {
        id: "locations",
        title: "Locations",
        type: "item",
        icon: <Icon.Map size={10} />,
        navLink: "/view/locations",
        permissions: ["admin", "editor"],
      }, {
        id: "vendors",
        title: "Vendors",
        type: "item",
        icon: <Icon.Layout size={10} />,
        navLink: "/view/vendors",
        permissions: ["admin", "editor"]
      }, {
        id: "users",
        title: "Users",
        type: "item",
        icon: <Icon.Users size={10} />,
        navLink: "/view/users",
        permissions: ["admin", "editor"]
      }, {
        id: "subscription",
        title: "Subscription",
        type: "item",
        icon: <Icon.Framer size={10} />,
        navLink: "/view/subscription",
        permissions: ["admin", "editor"]
      },  {
        id: "tdforecast",
        title: "TD Forecast",
        type: "item",
        icon: <Icon.BarChart2 size={10} />,
        permissions: ["admin", "editor"],
        navLink: "/view/tdforecast",
      }, {
        id: `buforecast`,
        title: "BU Forecast",
        type: "item",
        icon: <Icon.BarChart size={10} />,
        permissions: ["admin", "editor"],
        navLink: "/view/buforecast",
      }, {
        id: `ro`,
        title: "RO",
        type: "item",
        icon: <Icon.BarChart size={10} />,
        permissions: ["admin", "editor"],
        navLink: "/view/ro",
      }, {
        id: "settings",
        title: "Settings",
        type: "item",
        icon: <Icon.Settings size={10} />,
        navLink: "/view/settings",
        permissions: ["admin", "editor"]
      }
    ]
  }, {
    id: "organization",
    title: "Organization",
    type: "item",
    icon: <Icon.Globe size={30} />,
    permissions: ["admin", "editor"],
    navLink: "/organization",
    parentOf: ['/organization/view/:OrganizationID/:filter', '/organization/new/create']
  },
  // {
  //   id: "roi-booster",
  //   title: "ROI Booster",
  //   type: "item",
  //   icon: <Icon.TrendingUp size={30} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/roi-booster",
  // } ,
  {
    id: "settings",
    title: "Settings",
    type: "item",
    icon: <Icon.Settings size={30} />,
    permissions: ["admin", "editor"],
    navLink: "/settings",
  }
]

export default navigationConfig
